
export default {
  name: "largeCard",
  props: {
    card: Object,
    restrict: Boolean,
    index: Number
  },
  mounted(){
    
        let self = this;
        this.$root.$on('filterstate', $filter => {
            
            self.filter($filter);

        });

  },
  methods: {
     filter($filter)
        {

            if (!Array.isArray($filter))
            {
                $filter = new Array($filter);
            }

            this.showCard = false;

            console.log("filter");

                if ($filter.length > 0 && $filter[0] != undefined)
                {                
                    console.log("filter exists", $filter);
                    if (this.card.tags && this.card.tags.length > 0)
                    {


                        console.log("tags", this.card.tags);

                        this.card.tags.forEach(c => {
                            $filter.forEach(f => {

                                if (c == f)
                                {
                                    console.log("match", c, f);
                                    this.showCard = true;
                                }
                            });
                        })         

                        if (this.showCard === false)
                        {
                            console.log("no tag match, force off");
                            this.showCard = false;
                        }     
                        else{
                            console.log("still showing", this.showCard);
                        }
                    }
                    else
                    {
                        this.showCard = false;
                        console.log("no tag");
                    }
                }
                else
                {
                        console.log("no filters applied");
                    this.showCard = true;
                }
 

                
        }
  },
  data()
  {
      return {
         showCard: true
      }
  },
    async fetch()
    {
      
        if (this.$route && this.$route.query.filter != null)
        {
            this.showCard = false;
        }
        else
        {
          this.showCard = true;
        }
    }
};
